import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TextArea from './TextArea';

const Text = ({ value, onChange, onFocus }) => {
  return (
    <TextContainer>
      <TextArea placeholder="본문을 입력하세요" value={value} onChange={onChange} onFocus={onFocus} />
    </TextContainer>
  );
};

Text.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

Text.defaultProps = {
  onFocus: () => {},
};

const TextContainer = styled.div`
  margin: 24px 0px 28px 0px;
  background-color: 'transparent';
`;

export default Text;
